<nb-layout center="false" windowMode [ngClass]="customClass ? customClass : null">
  <nb-layout-column>
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>